var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"CallCell"}},[_c('button',{attrs:{"id":"cellButton","disabled":_vm.disabled || _vm.clicked},on:{"click":function($event){return _vm.callCard()}}},[_vm._v(_vm._s(_vm.cardView))])])}
var staticRenderFns = []

export { render, staticRenderFns }